import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { EtaStatus } from "../../../graphql/generated";
import { useTranslation } from "react-i18next";
import enumLabel from "../../../utils/labels/enumLabel";
import { etaStatusPaletteColor } from "./tripLiveEtaDisplay";

export const TripEtaStatusDot = ({
  etaStatus,
  showLabel = false,
}: {
  etaStatus: EtaStatus;
  showLabel?: boolean;
}) => {
  const { t } = useTranslation("planning");
  const paletteKey = etaStatusPaletteColor[etaStatus];
  if (!paletteKey) {
    return null;
  }

  const label = t(`etaStatusLabel.${etaStatus}`, {
    defaultValue: enumLabel(etaStatus) || etaStatus,
  }) as string;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Tooltip title={label}>
        <Box
          component="span"
          data-testid="trip-eta-status-dot"
          sx={{
            display: "inline-block",
            width: 10,
            height: 10,
            borderRadius: "50%",
            bgcolor: `${paletteKey}.main`,
            flexShrink: 0,
          }}
        />
      </Tooltip>
      {showLabel ? <Typography variant="caption">{label}</Typography> : null}
    </Stack>
  );
};
